import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sn-drawer-footer',
  templateUrl: './drawer-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-drawer__footer',
  },
})
export class SnDrawerFooterComponent {
  constructor() {}
}
